/* eslint-disable prettier/prettier */
import { get, post, DELETE } from '../axios'

// delete
export function buyitwith_delete_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// list
export function buyitwith_list_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/list`,
    map,
    option
  ).then(response => response)
}

// modify
export function buyitwith_modify_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/modify`,
    map,
    option
  ).then(response => response)
}

// page
export function buyitwith_page_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/page`,
    map,
    option
  ).then(response => response)
}

// query
export function buyitwith_query_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/query/${map.id}`,
    map,
    option
  ).then(response => response)
}

// save
export function buyitwith_save_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/save`,
    map,
    option
  ).then(response => response)
}

// 查询biw置顶列表
export function buyitwith_fix_page_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/page`,
    map,
    option
  ).then(response => response)
}

// 编辑biw置顶
export function buyitwith_fix_upsert_get (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/upsert`,
    map,
    option
  ).then(response => response)
}

// 编辑biw置顶
export function buyitwith_fix_upsert_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/upsert`,
    map,
    option
  ).then(response => response)
}

// 删除biw置顶
export function buyitwith_fix_delete_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 批量删除biw置顶
export function buyitwith_fix_batchDel_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/batchDel`,
    map,
    option
  ).then(response => response)
}

// exportExcel
export function buyitwith_fix_exportExcel_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/exportExcel`,
    map,
    option
  ).then(response => response)
}

// importExcel
export function buyitwith_fix_importExcel_post (map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/fix/importExcel`,
    map,
    option
  ).then(response => response)
}

// delete
export function biw_v2_delete_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/biw/v2/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// list
export function biw_v2_list_post (map, option) {
  return post(`${process.env.VUE_APP_BUYITWITH}/biw/v2/list`, map, option).then(
    response => response
  )
}

// modify
export function biw_v2_modify_post (map, option) {
  return post(`${process.env.VUE_APP_BUYITWITH}/biw/v2/modify`, map, option).then(
    response => response
  )
}

// page
export function biw_v2_page_post (map, option) {
  return post(`${process.env.VUE_APP_BUYITWITH}/biw/v2/page`, map, option).then(
    response => response
  )
}

// query
export function biw_v2_query_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/biw/v2/query/${map.id}`,
    map,
    option
  ).then(response => response)
}

// save
export function biw_v2_save_post (map, option) {
  return post(`${process.env.VUE_APP_BUYITWITH}/biw/v2/save`, map, option).then(
    response => response
  )
}

// 新增指引
export function sizeGuide_heightWeight_add_post (map, option) {
  return post(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/add`,
    map,
    option
  ).then(response => response)
}

// 删除指引
export function sizeGuide_heightWeight_delete_id_delete (map, option) {
  return DELETE(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 查询指引
export function sizeGuide_heightWeight_detail_id_get (map, option) {
  return get(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 编辑指引
export function sizeGuide_heightWeight_edit_post (map, option) {
  return post(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/edit`,
    map,
    option
  ).then(response => response)
}

// 指引状态修改
export function sizeGuide_heightWeight_enable_id_enable_get (map, option) {
  return get(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/enable/${map.id}/${map.enable}`,
    map,
    option
  ).then(response => response)
}

// 指引列表（分页查询）
export function sizeGuide_heightWeight_page_get (map, option) {
  return get(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/page`,
    map,
    option
  ).then(response => response)
}

// 查询已使用typeName列表
export function sizeGuide_heightWeight_typeName_queryUsedList_get (map, option) {
  return get(
    `${process.env.VUE_APP_SIZEGUIDE}/sizeGuide/heightWeight/typeName/queryUsedList`,
    map,
    option
  ).then(response => response)
}
